module.exports = __webpack_public_path__ + "static/media/img2.daf57133.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Galeria/img2.jpg
// module id = 75
// module chunks = 0